import { useCallback } from 'react';

import { stripHtmlTags } from '@change-corgi/core/html';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { useCurrentUser } from '#src/app/shared/hooks/session';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

// oxlint-disable-next-line eslint/max-lines-per-function
export function useGetDashboardShareContent(): ShareActionsOptions<ShareChannel>['getContent'] {
	const { translate } = useI18n();
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const currentUser = useCurrentUser();
	const currentUserName = currentUser?.shortDisplayName || '';
	const descriptionText = stripHtmlTags(petition.description);

	return useCallback(
		(channel, type, { url }) => {
			switch (channel) {
				case 'whatsapp':
					return translate('corgi.petition.starter_dashboard.grow_petition.share_modal.share_text.whatsapp.message');
				case 'twitter':
					return translate('fe.components.petition_share.share_text_twitter', {
						petition_title: petition.displayTitle,
					});
				case 'sms':
					return translate('fe.components.petition_share.share_text_sms');
				case 'line':
					return translate('fe.components.petition_share.share_text_line');
				case 'facebookMessenger':
					return translate('fe.components.petition_share.share_text');
				case 'email':
					if (type === 'title') return petition.displayTitle;
					return translate('corgi.petition.starter_dashboard.grow_petition.share_modal.share_text.email.body', {
						title: petition.displayTitle,
						number: petition.signatureState.signatureGoal.displayedLocalized,
						url,
						from: currentUserName,
					});
				case 'nextdoor':
					if (descriptionText.length > 900) {
						return translate(
							'corgi.petition.starter_dashboard.grow_petition.share_modal.share_text.nextdoor.truncated_body',
							{
								title: petition.displayTitle,
								description: descriptionText.slice(0, descriptionText.lastIndexOf(' ', 900)),
							},
						);
					}
					return translate('corgi.petition.starter_dashboard.grow_petition.share_modal.share_text.nextdoor.body', {
						title: petition.displayTitle,
						description: descriptionText,
					});
				default:
					return '';
			}
		},
		[
			translate,
			petition.displayTitle,
			petition.signatureState.signatureGoal.displayedLocalized,
			currentUserName,
			descriptionText,
		],
	);
}
